import { create } from 'zustand';

export type SelectionKind = 'panel' | 'button' | 'partyline' | null;

interface UiState {
  selection: { kind: SelectionKind; id: string | null };
  select(kind: SelectionKind, id: string | null): void;
  clearSelection(): void;
}

export const useUiStore = create<UiState>((set) => ({
  selection: { kind: null, id: null },
  select(kind, id) {
    set({ selection: { kind, id } });
  },
  clearSelection() {
    set({ selection: { kind: null, id: null } });
  },
}));
